import { useState } from "react";
import { gossipFaqs } from "@/mocks/faqs";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="关于网报吃瓜，常被问到的几个问题"
          desc="如果你刚来，先看这几条，能快速了解我们怎么定义事件串，以及内容边界在哪里。"
          align="center"
        />

        <div className="mx-auto mt-8 max-w-3xl">
          <dl className="flex flex-col gap-3">
            {gossipFaqs.map((faq, index) => {
              const isOpen = open === index;
              return (
                <Reveal key={faq.question} delay={index * 50}>
                  <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                      >
                        <span className="text-sm font-semibold text-foreground-900 md:text-base">{faq.question}</span>
                        <i
                          className={`shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        />
                      </button>
                    </dt>
                    <dd
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <p className="overflow-hidden px-5 text-sm leading-relaxed text-foreground-600">
                        <span className="block pb-5">{faq.answer}</span>
                      </p>
                    </dd>
                  </div>
                </Reveal>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}